import EncounterTimer from "components/shared/EncounterTimer/EncounterTimer";
import React, { useEffect } from "react";

export default function Surveys() {
  useEffect(() => {
    window.scroll({
      top: 172,
      left: 0,
      behavior: "smooth"
    });
  }, []);

  return (
    <div>
      <EncounterTimer />
      {/*<iframe src={'https://respiratory.prd.life365inc.com/#'} style={{width: '100%', height: '600px'}}/>*/}
      <iframe
        src={"https://phs.avixena.com"}
        style={{ width: "90%", height: "500px", marginLeft: "6%" }}
      />
    </div>
  );
}
